'use strict';

var _classCallCheck = require("/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TransformStream = require('readable-stream').Transform;

var pingMessageConverter = require('./ping-message-converter');

var PingMessageStream = /*#__PURE__*/function (_TransformStream) {
  _inherits(PingMessageStream, _TransformStream);

  var _super = _createSuper(PingMessageStream);

  function PingMessageStream(options) {
    _classCallCheck(this, PingMessageStream);

    var opts = Object.assign(options || {}, {
      objectMode: true
    });
    return _super.call(this, opts);
  }

  _createClass(PingMessageStream, [{
    key: "_transform",
    value: function _transform(obj, enc, callback) {
      try {
        var msg = pingMessageConverter(obj);
        this.push(msg);

        if (!msg.success) {
          throw new Error(msg.text);
        }
      } catch (err) {
        return callback(err);
      }

      callback();
    }
  }]);

  return PingMessageStream;
}(TransformStream);

module.exports = PingMessageStream;